module.exports = __webpack_public_path__ + "img/q6.625f7935.png";